import { useQueries } from '@tanstack/react-query';

import { edgeStackQueryOptions } from '@/react/edge/edge-stacks/queries/useEdgeStack';

import { WorkflowArtifact } from '../types';

export function useArtifactEdgeStacks(artifacts: Array<WorkflowArtifact>) {
  return useQueries({
    queries: artifacts.map((artifact) => edgeStackQueryOptions(artifact.id)),
  });
}
